<div [className]="className" [style]="styleName">

      <div [className]="inputClass" [style]="inputStyle" >
            <img src="refresh/assets/images/info.png" style="width:2.1em; margin-top:0.5em; margin-left:0.2em;"  
                 alt="Information Box"/>
      </div>
      
      <div [className]="textClass" [style]="textStyle" style="font-size:0.90em">
            <div [hidden]="!label" [html]="label" [param]="labelParam" [className]="labelClass" [style]="labelStyle"></div>
            <ng-content></ng-content>
      </div>
 </div>

